(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-hero-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pro-hero')) {
  class ProHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;
      this.delay = (parseFloat(this.dataset.interval) || 7) * 1000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.wantsAutoplay = this.dataset.autoplay === 'true' && !this.reduced && this.slides.length > 1 && !(window.Shopify && window.Shopify.designMode);
      this.paused = false;
      this.timer = null;
      this.show(0, false);
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1, true));
      if (next) next.addEventListener('click', () => this.step(1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i, true)));
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resume());
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.step(-1, true);
        if (e.key === 'ArrowRight') this.step(1, true);
      });
      let startX = 0, startY = 0;
      this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; startY = e.touches[0].clientY; this.pause(); }, { passive: true });
      this.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.step(dx < 0 ? 1 : -1, true);
        this.resume();
      }, { passive: true });
      document.addEventListener('visibilitychange', this.onVisibility = () => (document.hidden ? this.stop() : this.resume()));
      this.addEventListener('shopify:block:select', (e) => { const i = this.slides.indexOf(e.target); if (i > -1) this.show(i, false); });
      this.start();
    }
    disconnectedCallback() { this.stop(); document.removeEventListener('visibilitychange', this.onVisibility); }
    show(i, user) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s, n) => {
        const active = n === this.index;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      this.dots.forEach((d, n) => d.setAttribute('aria-current', n === this.index ? 'true' : 'false'));
      if (user) this.start();
    }
    step(d, user) { this.show(this.index + d, user); }
    start() {
      this.stop();
      if (this.wantsAutoplay && !this.paused) this.timer = setInterval(() => this.step(1, false), this.delay);
    }
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    pause() { this.paused = true; this.stop(); }
    resume() { this.paused = false; this.start(); }
  }
  customElements.define('pro-hero', ProHero);
}

  } catch(e) { console.error(e); }
})();
})();
